const welcomeImage = require('./welcomeimage.png')
const campxLogoWhite = require('./campx_logo_white.png')
const avatarImage = require('./avatar.png')
const NoPartImage = require('./NoPartImage.png')
const permissionDenied = require('./403.png')
export { avatarImage, campxLogoWhite, NoPartImage, permissionDenied, welcomeImage }
